import { CommonModule, JsonPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { AnswerEntryFormComponent } from '@new-core/components/inputs-gi/answer-entry-form/answer-entry-form.component';
import { TranslateModule } from '@ngx-translate/core';
import { FitTextModule, FormFieldModule, TimerModule } from '@shared/components/games';
import { CalculatorModule } from '@shared/components/games/calculator/calculator.module';
import { AlphabetPickerModule } from '../../../shared/components/games/alphabet-picker/alphabet-picker.module';
import { NumAndLetterMemoryControllerComponent } from './num-and-letter-memory-controller/num-and-letter-memory-controller.component';
import { NumAndLetterMemoryCorrectAnswerPreviewComponent } from './num-and-letter-memory-preview/num-and-letter-memory-answer-preview/num-and-letter-memory-answer-preview.component';
import { NumAndLetterMemoryExamplePreviewComponent } from './num-and-letter-memory-preview/num-and-letter-memory-example-preview/num-and-letter-memory-example-preview.component';
import { NumAndLetterMemoryParametersPreviewComponent } from './num-and-letter-memory-preview/num-and-letter-memory-parameters-preview/num-and-letter-memory-parameters-preview.component';
import { NumAndLetterMemoryUserAnswerPreviewComponent } from './num-and-letter-memory-preview/num-and-letter-memory-user-answer-preview/num-and-letter-memory-user-answer-preview.component';
import { NumAndLetterMemorySettingsComponent } from './num-and-letter-memory-settings/num-and-letter-memory-settings.component';
import { GameInputComponent } from '@new-core/components/inputs-gi/game-input/game-input.component';

@NgModule({
  declarations: [
    NumAndLetterMemoryControllerComponent,
    NumAndLetterMemorySettingsComponent,
    NumAndLetterMemoryExamplePreviewComponent,
    NumAndLetterMemoryCorrectAnswerPreviewComponent,
    NumAndLetterMemoryUserAnswerPreviewComponent,
    NumAndLetterMemoryParametersPreviewComponent,
  ],
  exports: [
    NumAndLetterMemoryControllerComponent,
    NumAndLetterMemorySettingsComponent,
    NumAndLetterMemoryExamplePreviewComponent,
    NumAndLetterMemoryCorrectAnswerPreviewComponent,
    NumAndLetterMemoryUserAnswerPreviewComponent,
    NumAndLetterMemoryParametersPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    FitTextModule,
    TimerModule,
    CalculatorModule,
    FormFieldModule,
    AlphabetPickerModule,
    JsonPipe,
    GamesSharedModule,

    AnswerEntryFormComponent,
    GameInputComponent,
  ],
})
export class NumAndLetterMemoryModule {}
